export default __webpack_public_path__ + "static/media/fa_refresh (1).6e8ebfaa.svg";